export const getCurrencySymbol = (currencyCode: string): string => {
  const currencyMap: { [key: string]: string } = {
    USD: "US$",
    BRL: "R$",
    EUR: "€",
    GBP: "£",
  };
  return currencyMap[currencyCode] || currencyCode;
};

export const formatCurrencyValue = (
  value: number,
  currencyCode: string
): string => {
  const symbol = getCurrencySymbol(currencyCode);
  const formattedValue = value.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${symbol} ${formattedValue}`;
};
